import { Link, useLocation } from "react-router-dom";
import { Activity, LayoutDashboard, FileCheck, Home } from "lucide-react";

const navItems = [
  { path: "/", label: "Home", icon: Home },
  { path: "/test", label: "Test", icon: Activity },
  { path: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { path: "/certificate", label: "Certificate", icon: FileCheck },
];

export default function Navigation() {
  const location = useLocation();

  return (
    <header
      data-testid="main-navigation"
      className="bg-zinc-950/80 backdrop-blur-xl border-b border-white/10 sticky top-0 z-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
            <div className="w-9 h-9 rounded-lg bg-yellow-500 flex items-center justify-center">
              <Activity className="w-5 h-5 text-black" />
            </div>
            <span className="font-heading font-black text-lg tracking-tight text-white group-hover:text-yellow-500 transition-colors">
              SecureRTO
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path ||
                (item.path !== "/" && location.pathname.startsWith(item.path.split("/").slice(0, 2).join("/")));
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  data-testid={`nav-${item.label.toLowerCase()}`}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? "bg-yellow-500/10 text-yellow-500 border border-yellow-500/20"
                      : "text-zinc-400 hover:text-white hover:bg-white/5"
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {item.label}
                </Link>
              );
            })}
          </nav>

          {/* Mobile nav */}
          <nav className="flex md:hidden items-center gap-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  data-testid={`nav-mobile-${item.label.toLowerCase()}`}
                  className={`p-2 rounded-lg transition-colors ${
                    isActive
                      ? "bg-yellow-500/10 text-yellow-500"
                      : "text-zinc-400 hover:text-white"
                  }`}
                >
                  <Icon className="w-5 h-5" />
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </header>
  );
}
